import React from 'react'
import PropTypes from 'prop-types'

import FilterGrid from '../../../FilterGrid'

export default function Filter({ setFilters, filters }) {
  return (
    <div
      style={{
        marginBottom: '2px',
      }}
    >
      <FilterGrid
        prestationFilter={false}
        statusDriversFilter={false}
        dateLivraisonFilter={true}
        setFilters={setFilters}
        filtersValues={filters}
      />
    </div>
  )
}
Filter.propTypes = {
  setFilters: PropTypes.func,
  filters: PropTypes.object,
}
